import { keyBy } from "lodash";

import { IFilterConfig, IFilterLabelValue } from "../interfaces";

import { IAgentFilterItem } from "./agent-filter";
import { agentFilterConfigMultiple } from "./default-config-multiple";

export const agentFilterConfigSingle: IFilterConfig = {
  ...agentFilterConfigMultiple,
  title: "Author",
  getFilterLabelValues: (filterValues: string, agents: IAgentFilterItem[]): IFilterLabelValue[] => {
    if (filterValues === null) {
      return [];
    }
    const agentsMap = keyBy(agents, agent => agent.id);
    return [
      {
        key: filterValues,
        label: agentsMap[filterValues].name,
      },
    ];
  },
  multiple: false,
};
